import React, { useState } from 'react';

import type { MouseEvent } from 'react';

import { twMerge } from 'tailwind-merge';

import Icon from 'components/icon/icon';
import NavigationItem from 'components-new/navigation-bar/navigation-item';

export interface NavigationBarProps {
  links: Array<{
    id?: string;
    link: string;
    title: string;
    isSelected?: boolean;
    onClick?: (evt: MouseEvent<HTMLAnchorElement>) => void;
  }>;
  variant?: 'neutral';
  rightChild?: React.ReactNode;
  className?: string;
  navigationItemClassName?: string;
  navigationItemTypographyClassName?: string;
}

const NavigationBar: React.FC<NavigationBarProps> = (props) => {
  const { links, variant, rightChild } = props;
  const [open, setOpen] = useState(false);

  const logoPath = 'tadaah-logo-2024.svg';

  const tadaahLogo = `${window.STATIC_URL}assets/${logoPath}`;

  const navigationBarClassNames = twMerge(
    'flex flex-col justify-start items-start py-4',
    'lg:flex-row lg:justify-between lg:py-0 lg:h-[65px]',
    'border-b border-gray100',
    'px-6',
    variant === 'neutral' && 'bg-background-navigation',
  );

  const navigationClassNames = twMerge(
    'border-t-2 border-t-gray50  pt-1 lg:mt-0 px-0 ',
    'lg:flex lg:flex-row whitespace-nowrap w-full lg:w-auto lg:border-none',
    'lg:items-center lg:h-full lg:justify-center',
    'absolute bg-background-navigation lg:static z-[-1] lg:z-auto left-0',
    'transition-all  duration-300 ease-in',
    open ? 'top-[50px] opacity-100 mt-3 pb-3' : 'top-[-450px] opacity-0',
    'lg:opacity-100 lg:h-full',
  );

  const burgerClassNames = twMerge(
    'text-4xl absolute right-7 top-4 cursor-pointer lg:invisible',
    variant === 'neutral' ? 'text-primary' : 'text-gray50',
  );

  const boxShadow = '0px 4px 8px #97969914';

  return (
    <div
      className={twMerge('flex flex-col sticky top-0 z-10', props.className)}
    >
      <div className={navigationBarClassNames} style={{ boxShadow }}>
        <a className="flex justify-center items-center lg:h-full" href="/">
          <img src={tadaahLogo} height="35px" width="128px" alt="logo" />
        </a>
        <Icon
          onClick={() => setOpen((prev) => !prev)}
          icon={open ? 'close' : 'list'}
          size={28}
          className={burgerClassNames}
        />
        <div id="navigation" className={navigationClassNames}>
          {links.map((link) => {
            return (
              <NavigationItem
                key={link.id}
                {...link}
                className={props.navigationItemClassName}
                variant={variant}
                typographyClassName={props.navigationItemTypographyClassName}
              />
            );
          })}
        </div>
        {rightChild}
      </div>
    </div>
  );
};

export default NavigationBar;
